// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "section.select-target-language[data-v-cdb87d2a]{flex:1 0 auto}", "",{"version":3,"sources":["webpack://./view/register/components/select-course.vue"],"names":[],"mappings":"AACA,gDACI,aAAA","sourcesContent":["\nsection.select-target-language {\n    flex: 1 0 auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
